import React from 'react';
import { motion } from 'framer-motion';
import { Check, PawPrint } from 'lucide-react';
import { scrollToComprar } from '../utils';
const items = ['Querés mejorar la alimentación de tu perro', 'Te preocupa lo que contienen las croquetas', 'Querés recetas fáciles y económicas', 'No sabés por dónde empezar'];
export function IsForYou() {
  return <section className="py-12 md:py-16 px-4 bg-white" data-id="element-116">
      <div className="max-w-3xl mx-auto" data-id="element-117">
        <div className="text-center mb-8 md:mb-10" data-id="element-118">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-accent/10 text-accent mb-3" data-id="element-119">
            <PawPrint size={22} data-id="element-120" />
          </div>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-primary" data-id="element-121">
            Este ebook es para vos si...
          </h2>
        </div>

        <div className="bg-cream border border-cream-dark rounded-3xl p-6 md:p-8 shadow-sm" data-id="element-122">
          <ul className="grid sm:grid-cols-2 gap-3 md:gap-4" data-id="element-123">
            {items.map((text, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="bg-white rounded-xl p-4 flex items-center gap-3 border border-cream-dark" data-id="element-124">
                <div className="flex-shrink-0 w-7 h-7 rounded-full bg-primary text-white flex items-center justify-center" data-id="element-125">
                  <Check size={16} className="stroke-[3]" data-id="element-126" />
                </div>
                <span className="text-brown font-medium text-sm md:text-base leading-snug" data-id="element-127">
                  {text}
                </span>
              </motion.li>)}
          </ul>

          <div className="mt-7 text-center" data-id="element-128">
            <button onClick={scrollToComprar} className="bg-accent hover:bg-accent-hover text-white font-bold py-3 px-6 rounded-xl shadow-lg transform transition hover:-translate-y-1" data-id="element-129">
              SÍ, ESTO ES PARA MÍ
            </button>
          </div>
        </div>
      </div>
    </section>;
}